import { LegalLayout } from "@/components/LegalLayout";

const Terms = () => (
  <LegalLayout
    title="Terms of Service"
    description="The terms governing your use of Cash Isle."
    updated="May 13, 2026"
  >
    <h2>1. Agreement</h2>
    <p>
      By creating an account or using Cash Isle ("we", "us", "the Service"), you
      agree to these Terms. If you do not agree, do not use the Service. You must
      be at least 18 years old and legally able to enter contracts in your
      jurisdiction. Cash Isle is currently offered in The Bahamas.
    </p>

    <h2>2. Your account</h2>
    <p>
      You are responsible for keeping your sign-in credentials, PIN, and device
      secure. You must give us accurate information and keep it up to date.
      We may require identity verification (KYC) before you can send, receive,
      withdraw, or accept gigs above certain limits.
    </p>

    <h2>3. The wallet</h2>
    <p>
      Cash Isle provides a stored-value wallet for sending and receiving funds
      between users, paying merchants, posting and accepting gigs, and
      withdrawing to your bank. Balances are denominated in USD. We are not a
      bank and balances are not insured deposits.
    </p>

    <h2>4. Gigs and escrow</h2>
    <p>
      When you post a gig, the budget is held in escrow and released to the
      worker on your approval, on automatic approval after the dispute window,
      or by an admin resolution. When you accept a gig, you agree to deliver the
      described work in good faith and to upload truthful proof of completion.
      False proofs, fake reviews, or collusion to defraud the other party are
      grounds for permanent ban and forfeiture of funds.
    </p>

    <h2>5. Disputes</h2>
    <p>
      Either party may open a dispute. Disputes are reviewed using submitted
      evidence (proof media, GPS, chat, transaction history, risk signals) and
      resolved by an admin. Resolutions may be: full release to the worker, full
      refund to the poster, or a split. Resolutions are final at our reasonable
      discretion.
    </p>

    <h2>6. Fees</h2>
    <p>
      Sending money person-to-person is free. Withdrawals to bank, gig escrow,
      and merchant payments may incur fees disclosed in-app before you confirm.
      Fees may change with notice.
    </p>

    <h2>7. Prohibited use</h2>
    <ul>
      <li>Money laundering, terrorist financing, or sanctions evasion.</li>
      <li>Illegal goods or services, weapons, regulated drugs, gambling without licence.</li>
      <li>Fraud, chargebacks, fake disputes, identity misuse, or account farming.</li>
      <li>Reselling Cash Isle access or operating accounts on behalf of others.</li>
    </ul>
    <p>
      We may freeze, limit, or close accounts and reverse transactions that
      violate these rules.
    </p>

    <h2>8. Limits</h2>
    <p>
      Daily payout, gig budget, and withdrawal caps depend on your verification
      tier (Basic, Verified, Pro, Elite). Tiers are recomputed automatically.
    </p>

    <h2>9. Termination</h2>
    <p>
      You may close your account at any time after settling open balances and
      gigs. We may suspend or terminate access for violations or risk reasons.
    </p>

    <h2>10. Disclaimer & liability</h2>
    <p>
      The Service is provided "as is". To the maximum extent permitted by law we
      disclaim implied warranties and limit our aggregate liability to the
      greater of (a) fees you paid us in the prior 3 months or (b) USD $100.
    </p>

    <h2>11. Changes</h2>
    <p>
      We may update these Terms. Material changes will be announced in-app at
      least 7 days before they take effect. Continued use means acceptance.
    </p>

    <h2>12. Contact</h2>
    <p>support@cashisle.app</p>
  </LegalLayout>
);

export default Terms;
